import { useAdminSessionInit as i } from "../../../hooks/useAdminSessionInit/useAdminSessionInit.js";
import { Fragment as m, jsx as n } from "react/jsx-runtime";
var o = ({ children: r }) => (i(), /* @__PURE__ */ n(m, { children: r }));
export {
  o as AdminAppInitializer
};

//# sourceMappingURL=AdminAppInitializer.js.map